// AppRouter.tsx
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import routes from '.';
import { useAuthValidation } from '@/hooks/useAuthValidation';
import { AdminRoutes } from './AdminRoute';
import { RouteErrorElement } from '@/components/app/ErrorBoundary';

// Attach a route-level error boundary to each top-level route so a throw in
// one route branch renders the fallback within that branch instead of
// white-screening the entire shell. Existing per-route `errorElement`s (none
// today) are preserved.
function withRouteErrorElement(route: RouteObject): RouteObject {
  return route.errorElement
    ? route
    : { ...route, errorElement: <RouteErrorElement /> };
}

export default function AppRouter() {
  const role = useAuthValidation();

  const router = createBrowserRouter(
    [...routes, ...(role === 'admin' ? [AdminRoutes] : [])].map(
      withRouteErrorElement,
    ),
  );

  return <RouterProvider router={router} />;
}
